import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-app-checkbox",
  templateUrl: "./app-checkbox.component.html",
  styleUrls: ["./app-checkbox.component.css"],
})
export class AppCheckboxComponent implements OnInit {
  @Input() name: string;
  @Input() disabled: boolean = false;
  @Input() value: boolean;
  @Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}
}
